
//import { AreaListingsPageServerSideProps } from 'components/dynamic-page';
import { AreaPageListing, SingleAddress } from '@zoocasa/go-search';
import { AddressViewModel, AreaListingsPage, AreaListingsPageServerSideProps, AreaListingsPageViewModel, getAreaListingsPageServerSideProps } from 'components/pages/area-listings';
import HeadData from 'components/head-data';
import Layout from 'components/layout';
import { createAddressesApi, parsedAddressPathFromJson } from 'data/addresses';
import { createInsightsApi } from 'data/insights';
import { createNamedContentsApi } from 'data/named-content';
import { createSearchApi } from 'data/search';
import { createSeoLinksApi } from 'data/seo-links';
import { DynamicPageServerSideProps } from 'types';
import {
  createGetServerSideProps,
  HandlerType,
} from 'utils/next/shared-getServerSideProps';

const handler: HandlerType<serverSidePropsType> = async (context, features, tenant) => {
  const searchApi = createSearchApi();
  const addressesApi = createAddressesApi();
  const namedContentsApi = createNamedContentsApi();
  const insightsApi = createInsightsApi();
  const seoLinksApi = createSeoLinksApi(insightsApi);
  const props = await getAreaListingsPageServerSideProps(context, features, tenant, searchApi, addressesApi, namedContentsApi, insightsApi, seoLinksApi);
  return props;
};
export const getServerSideProps = createGetServerSideProps(handler);

type serverSidePropsType = DynamicPageServerSideProps<AreaListingsPageServerSideProps>;

export default function AreaPage({ routeName, props }: serverSidePropsType) {
  const {
    requestedAddress: requestedAddressData,
    electedAddress: electedAddressData,
    listings: listingsData,
    ...viewModelData
  } = props as AreaListingsPageViewModel<AddressViewModel>;

  const requestedAddress = parsedAddressPathFromJson(requestedAddressData);
  const electedAddress = SingleAddress.fromJSON(electedAddressData);
  /** We need to convert the listings data from a plain object back into an AreaPageListing Model */
  const listings = listingsData.map((listing: unknown) => AreaPageListing.fromJSON(listing));

  const viewModel: AreaListingsPageViewModel<AddressViewModel> = {
    requestedAddress,
    electedAddress,
    listings,
    ...viewModelData,
  };
  return (
    <Layout routeName={routeName}>
      {props.headTags && <HeadData data={props.headTags} />}
      <AreaListingsPage viewModel={viewModel}/>
    </Layout>
  );
}